export default __webpack_public_path__ + "static/media/Verified_Icon.bdb86fff.svg";